export class DiscountRequest {
  promoCode: string | null;
  subscriptionId: bigint;
  userId: null;

  constructor(promoCode: string | null, subscriptionId: bigint) {
    this.promoCode = promoCode;
    this.subscriptionId = subscriptionId;
    this.userId = null;
  }
}
